function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react/prop-types */
/**
 * Override React Table pagination component to be able to control Previous/Next
 */

import React, { Component } from 'react';
import classnames from 'classnames';
var defaultButton = function defaultButton(props) {
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button"
  }, props, {
    className: "-btn"
  }), props.children);
};
var ReactTablePagination = /*#__PURE__*/function (_Component) {
  _inherits(ReactTablePagination, _Component);
  var _super = _createSuper(ReactTablePagination);
  function ReactTablePagination(props) {
    var _this;
    _classCallCheck(this, ReactTablePagination);
    _this = _super.call(this);
    _this.getSafePage = _this.getSafePage.bind(_assertThisInitialized(_this));
    _this.changePage = _this.changePage.bind(_assertThisInitialized(_this));
    _this.applyPage = _this.applyPage.bind(_assertThisInitialized(_this));
    _this.prevPage = _this.prevPage.bind(_assertThisInitialized(_this));
    _this.nextPage = _this.nextPage.bind(_assertThisInitialized(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_this));
    _this.handleChangeCurrentPage = _this.handleChangeCurrentPage.bind(_assertThisInitialized(_this));
    _this.state = {
      page: props.page
    };
    return _this;
  }

  // eslint-disable-next-line react/no-deprecated
  _createClass(ReactTablePagination, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        page: nextProps.page
      });
    }
  }, {
    key: "getSafePage",
    value: function getSafePage(page) {
      if (isNaN(page)) {
        page = this.props.page;
      }
      if (this.props.canNextFromData) return page;
      return Math.min(Math.max(page, 0), this.props.pages - 1);
    }
  }, {
    key: "changePage",
    value: function changePage(page) {
      page = this.getSafePage(page);
      this.setState({
        page: page
      });
      if (this.props.page !== page) {
        this.props.onPageChange(page);
      }
    }
  }, {
    key: "applyPage",
    value: function applyPage(e) {
      if (e) {
        e.preventDefault();
      }
      var page = this.state.page;
      this.changePage(page === '' ? this.props.page : page);
    }
  }, {
    key: "prevPage",
    value: function prevPage() {
      if (!this.props.canPrevious) return;
      this.changePage(this.props.page - 1);
    }
  }, {
    key: "nextPage",
    value: function nextPage() {
      var _this$props = this.props,
        data = _this$props.data,
        pageSize = _this$props.pageSize,
        page = _this$props.page;
      var canNext = this.props.canNextFromData ? data && data.length == pageSize : this.props.canNext;
      if (!canNext) return;
      this.changePage(page + 1);
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      if (event.which === 13 || event.keyCode === 13) {
        this.applyPage();
      }
    }
  }, {
    key: "handleChangeCurrentPage",
    value: function handleChangeCurrentPage(event) {
      var val = event.target.value;
      var page = val - 1;
      if (val === '') {
        return this.setState({
          page: val
        });
      }
      this.setState({
        page: this.getSafePage(page)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        pages = _this$props2.pages,
        page = _this$props2.page,
        pageSize = _this$props2.pageSize,
        data = _this$props2.data,
        showPageJump = _this$props2.showPageJump,
        canPrevious = _this$props2.canPrevious,
        className = _this$props2.className,
        _this$props2$Previous = _this$props2.PreviousComponent,
        PreviousComponent = _this$props2$Previous === void 0 ? defaultButton : _this$props2$Previous,
        _this$props2$NextComp = _this$props2.NextComponent,
        NextComponent = _this$props2$NextComp === void 0 ? defaultButton : _this$props2$NextComp,
        _this$props2$showTota = _this$props2.showTotalPages,
        showTotalPages = _this$props2$showTota === void 0 ? true : _this$props2$showTota;
      var canNext = this.props.canNextFromData ? data && data.length == pageSize : this.props.canNext;
      return /*#__PURE__*/React.createElement("div", {
        className: classnames(className, '-pagination'),
        style: this.props.style
      }, /*#__PURE__*/React.createElement("div", {
        className: "-previous"
      }, /*#__PURE__*/React.createElement(PreviousComponent, {
        onClick: this.prevPage,
        disabled: !canPrevious
      }, this.props.previousText)), /*#__PURE__*/React.createElement("div", {
        className: "-center"
      }, /*#__PURE__*/React.createElement("span", {
        className: "-pageInfo"
      }, this.props.pageText, ' ', showPageJump ? /*#__PURE__*/React.createElement("div", {
        className: "-pageJump"
      }, /*#__PURE__*/React.createElement("input", {
        type: this.state.page === '' ? 'text' : 'number',
        onChange: this.handleChangeCurrentPage,
        value: this.state.page === '' ? '' : this.state.page + 1,
        onBlur: this.applyPage,
        onKeyPress: this.handleKeyPress
      })) : /*#__PURE__*/React.createElement("span", {
        className: "-currentPage"
      }, page + 1), ' ', showTotalPages ? /*#__PURE__*/React.createElement(React.Fragment, null, this.props.ofText, " ", /*#__PURE__*/React.createElement("span", {
        className: "-totalPages"
      }, pages || 1)) : null)), /*#__PURE__*/React.createElement("div", {
        className: "-next"
      }, /*#__PURE__*/React.createElement(NextComponent, {
        onClick: this.nextPage,
        disabled: !canNext
      }, this.props.nextText)));
    }
  }]);
  return ReactTablePagination;
}(Component);
export { ReactTablePagination as default };